export default function (error) {
  if (!error.response) {
    console.info(error);
    return Promise.reject(error);
  }
  const status = error.response.status;
  console.log('status', status);
  switch (status) {
    case 404:
      window.location.href = '/404';
      break;
    case 422:
      console.info(error.response.data);
      return Promise.reject(error.response.data);
    default:
      console.info(`Status ${status} not handled.`);
      break;
  }

  return Promise.reject(error);
}



// WEBPACK FOOTER //
// ./src/common/api/errorResponseInterceptor.js